module.exports = __webpack_public_path__ + "static/benchmarking 5-c38e80b83808e181d27f8c9dd2341571.png";